import RuleSetLibrary from "../../sports/tennis/rules/ruleset-library";
import BaseRuleSetProcessor from "./base-ruleset-processor";
import TennisRulesetContext from "../../sports/tennis/tennis-ruleset-context";

class TennisRuleSetProcessor extends BaseRuleSetProcessor {
    async _process(gameContext, eventConfiguration, { matches }) {
        const ruleSetContext = new TennisRulesetContext();

        if (gameContext && gameContext.ruleSetId) {
            const ruleSet = RuleSetLibrary.getRuleSetById(
                gameContext.ruleSetId
            ).rules;

            gameContext.setHomeScore(0);
            gameContext.setVisitorScore(0);
            gameContext.winnerTeamId = null;

            for (const match of matches) {
                await this._processTree(
                    ruleSet,
                    gameContext,
                    ruleSetContext,
                    eventConfiguration,
                    { match }
                );
            }
        }

        return { ruleSetContext };
    }
}

export default new TennisRuleSetProcessor();
